<template>
  <div id="app">
    <Navbar />
    <router-view />
    <FloatFeedback />
    <Rodape />
  </div>
</template>
<script>
import FloatFeedback from "./components/FloatFeedback";
import Navbar from "./components/Navbar";
import Rodape from "./components/Rodape";
export default {
  components: { FloatFeedback, Navbar, Rodape },
};
</script>
<style>
@import url("./assets/theme.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600&display=swap");
#app {
  font-family: "Inter", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
